import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

type SimpleConfig = SensorElementConfig<Record<string, never>, typeof SensorConversions.unity>;

export const stemRadiusChangeElementConfig: SimpleConfig = {
    legalConvertedRange: [-32000, 32000],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "micrometer",
    convertedUnits: "micrometer",
    unitCategory: "stemRadiusChange",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        { parameters: {}, decodedValue: 9510, convertedValue: 9510 },
        { parameters: {}, decodedValue: -1500, convertedValue: -1500 },
    ],
} as const;
